export default __webpack_public_path__ + "media/images/favicon-e46a9cd0cf05cb065797d0464409ddea.png";